import { Capacitor } from '@capacitor/core'

/**
 * Platform detection composable for detecting mobile vs web environments
 * @returns {Object} Platform detection utilities
 */
export const usePlatform = () => {
  // Check if running in Capacitor native app
  const isNative = Capacitor.isNativePlatform()

  // Get current platform
  const platform = Capacitor.getPlatform() // 'ios', 'android', 'web'

  // Platform-specific checks
  const isAndroid = platform === 'android'
  const isIOS = platform === 'ios'
  const isWeb = platform === 'web'
  const isMobile = isAndroid || isIOS

  // Check if running in mobile browser (not native app)
  const isMobileBrowser = computed(() => {
    if (process.server) return false
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  })

  // Get platform version
  const getPlatformVersion = async () => {
    try {
      const { App } = await import('@capacitor/app')
      const info = await App.getInfo()
      return info.version
    } catch (error) {
      console.warn('Could not get app version:', error)
      return null
    }
  }

  // Check if specific plugin is available
  const isPluginAvailable = (pluginName) => {
    return Capacitor.isPluginAvailable(pluginName)
  }

  // Convert web URL to native path if needed
  const convertFileSrc = (url) => {
    return Capacitor.convertFileSrc(url)
  }

  return {
    isNative,
    platform,
    isAndroid,
    isIOS,
    isWeb,
    isMobile,
    isMobileBrowser,
    getPlatformVersion,
    isPluginAvailable,
    convertFileSrc
  }
}
